import { AdTypes } from '../../../constants/ad-type';
import { RsaEditor } from './rsa-editor';
import { MmaEditor } from './mma-editor';
import { DsaEditor } from './dsa-editor';

export const Editors = {
  [AdTypes.ResponsiveSearch]: RsaEditor,
  [AdTypes.Responsive]: MmaEditor,
  [AdTypes.DynamicSearch]: DsaEditor,
};
